import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import styles from './PromoUsageWarningDialog.module.scss'

const PromoUsageWarningDialog = ({ promoCode, onClose, onConfirm }) => (
  <ConfirmationDialog
    title={<>{promoCode} is already in use</>}
    onClose={onClose}
    onConfirm={onConfirm}
    positiveMessage="Yes, I want to use it"
    negativeMessage="Go back"
    hasDangerousAction={true}
  >
    <p className={styles.usageWarningDialogParagraph}>
      The promo code you've entered, {promoCode}, has been already used for numerous
      bookings. We highly recommend generating a distinct code specifically for Directful
      to ensure accurate conversion data tracking.
    </p>
    <p className={styles.usageWarningDialogParagraph}>
      Do you still want to use {promoCode}?
    </p>
  </ConfirmationDialog>
)

export default PromoUsageWarningDialog
